import { Button } from "./button";
import { cn } from "@/lib/utils";
import { ButtonProps } from "./button";
import { forwardRef } from "react";

// Custom AstroPet button variants using the design system
export const HeroButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        className={cn(
          "gradient-primary text-primary-foreground hover:opacity-90 glow-primary",
          "transition-smooth font-semibold text-lg px-8 py-6 rounded-2xl",
          "border-0 shadow-lg hover:scale-105 active:scale-95",
          className
        )}
        {...props}
      >
        {children}
      </Button>
    );
  }
);

export const GlassButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        className={cn(
          "glass text-foreground hover:bg-white/10",
          "transition-smooth border border-white/20",
          "backdrop-blur-xl hover:border-white/30",
          className
        )}
        {...props}
      >
        {children}
      </Button>
    );
  }
);

export const SecondaryButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        className={cn(
          "bg-secondary text-secondary-foreground hover:bg-secondary/90",
          "transition-smooth shadow-lg hover:scale-105 active:scale-95",
          className
        )}
        {...props}
      >
        {children}
      </Button>
    );
  }
);

HeroButton.displayName = "HeroButton";
GlassButton.displayName = "GlassButton";
SecondaryButton.displayName = "SecondaryButton";